export default __webpack_public_path__ + "static/media/profile.fec3df8a.webp";